/* index.js */
/* Required Features:
1. Firebase Initialization: Centralized setup of the Firebase app and services.
2. Auth Persistence: Explicitly sets 'browserLocalPersistence' to ensure users stay logged in until they manually log out.
3. Global Context Injection: Wraps the application in the FirebaseContext to provide auth and db instances throughout the app.
*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth'; //
import { getFirestore } from 'firebase/firestore';
import './index.css';
import App from './App';

// Configuration
const firebaseConfig = {
  apiKey: "AIzaSyDj5t3R1dKAzIobJ7fUYfu93vYzltg3FTc",
  authDomain: "professor-maclid.firebaseapp.com",
  projectId: "professor-maclid",
  storageBucket: "professor-maclid.firebasestorage.app",
  appId: "1:942037426113:web:f62ee02b54b5b675ba5940",
  measurementId: "G-YY3FPW08BF"
};

// Feature: Firebase Initialization
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// Feature: Auth Persistence
// This ensures that the user's session is saved in local storage.
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Auth persistence set to LOCAL");
  })
  .catch((error) => {
    console.error("Could not set auth persistence:", error);
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Passing initialized instances down to avoid re-init in App.js */}
    <App authInstance={auth} dbInstance={db} />
  </React.StrictMode>
);